import * as React from 'react';
import { StatusField, TextField } from '~/components';
import { Grid } from '@material-ui/core';
import { isEmpty } from 'lodash';
import Field from './Field';
import { CellProps } from './CellProps';

const ListReportingStatusField = (props: CellProps<any>) => {
  const { rowData } = props;
  const ledgerMappingStatusBySystem = rowData?.ledgerMappingStatusBySystem;
  return (
    <Field {...props}>
      <Grid container wrap='nowrap' spacing={3}>
        {ledgerMappingStatusBySystem && !isEmpty(ledgerMappingStatusBySystem)
          ? Object.entries(ledgerMappingStatusBySystem).map(([system, status]) => (
              <Grid item key={system}>
                <TextField compact label={system}>
                  <StatusField status={status} />
                </TextField>
              </Grid>
            ))
          : null}
      </Grid>
    </Field>
  );
};

export default ListReportingStatusField;
